import * as ActionAuth from '../../../../core/action/Auth';
import * as ActionLogin from '../../../../module/Login/Store';

import { Modal, message } from 'antd';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import axios from 'axios';
import moment from 'moment';

export function* S_downloadMultipleWaybill(action: any) {
  const state = yield select();
  const token = state.Auth.Token;
  const statusTokenRefresh = state.Auth.StatusTokenRefresh;
  const config = {
    Authorization: `bearer ${token}`,
    'Content-type': 'application/json',
  };
  const key = 'download';
  const FileData = state.PrintWaybill.FormPrintWaybill.FileData;
  const SeparatorAddress = state.PrintWaybill.FormPrintWaybill.SeparatorAddress;
  const NoTelp = state.PrintWaybill.FormPrintWaybill.NoTelp;
  const CodeBrankas = state.PrintWaybill.FormPrintWaybill.CodeBrankas;

  // const Watermark = state.PrintWaybill.FormPrintWaybill.Watermark;
  let DateNow = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
  const file_name2 = `Waybill Bulk - ${DateNow}.pdf`;

  function ResponseDownload(data: any) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    const file_name = file_name2;
    link.href = url;
    link.setAttribute('download', file_name);
    document.body.appendChild(link);
    link.click();
  }
  try {
    const { data } = yield call(
      axios.post,
      `${process.env.REACT_APP_URL}/Delivery/DownloadWaybillPdf/Upload`,
      {
        fileString: FileData,
        separator: SeparatorAddress,
        NoTelp: NoTelp,
        CodeBrankas: CodeBrankas,
        watermark: true,
      },
      {
        responseType: 'blob',
        headers: config,
        onDownloadProgress: (progressEvent: any) => {
          const { loaded, total } = progressEvent;
          let percentProgress = Math.floor((loaded * 100) / total);

          // let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

          if (percentProgress < 100) {
            message.loading({
              content: 'Loading ' + percentProgress + '%',
              key,
            });
          } else if (percentProgress === 100) {
            Modal.destroyAll();
            message.success({
              content: 'Download Berhasil',
              key,
              duration: 1.5,
            });
          } else if (percentProgress === Infinity) {
            Modal.destroyAll();
            message.error({
              content: 'Download Gagal',
              key,
              duration: 3,
            });
          }
        },
      }
    );
    ResponseDownload(data);
    if (statusTokenRefresh === true) {
      yield put(ActionAuth.changeStatusTokenRefresh(false));
    }
  } catch (error) {
    if (error.response.data.Message === 'Network Error') {
      message.error({
        content: 'Download Gagal',
        key,
        duration: 3,
      });
    } else if (error.response.data.Message === 'No delivery found!') {
      message.error({
        content: 'Waybill tidak tersedia',
        key,
        duration: 3,
      });
    } else {
      yield put(ActionLogin.errorHandling(action, error));
    }
  }
}

export function* SM_downloadMultipleWaybill() {
  yield takeLatest('DOWNLOAD_MULTIPLE_WAYBILL', S_downloadMultipleWaybill);
}
